import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

export function setupFontAwesome(_library: FaIconLibrary) {
  // Los iconos se importan de forma individual en cada componente,
  // por lo que no registramos packs globales para permitir el tree-shaking.
}
